export const KEY_CONTACT_ROLES = [
  'Partner Signer',
  'HP Champion',
  'L&R Champion',
  'Data Collection Contact',
]

export const MNGR_ROLES = ['AOM', 'RAM', 'PBM', 'SuperAdmin']
